var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseIconOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_10712)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_498_10712",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 33,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.77832,
    width: 32,
    height: 44,
    fill: "#EEEEEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_498_10712)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.77832,
    y: 1,
    width: 33.6842,
    height: 43.0222,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.77832,
    width: 32,
    height: 34,
    fill: "#F46940"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.77832,
    y: 41,
    width: 32,
    height: 2.93333,
    fill: "#F46940"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.77832,
    y: 34,
    width: 32,
    height: 10,
    fill: "#D7D7D7"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    y: 36,
    width: 4,
    height: 8,
    fill: "#614E4E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7783,
    y: 36,
    width: 4,
    height: 8,
    fill: "#614E4E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7783,
    y: 36,
    width: 4,
    height: 8,
    fill: "#614E4E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    y: 34,
    width: 17,
    height: 2,
    fill: "#C0C0C0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7783,
    y: 34,
    width: 4,
    height: 2,
    fill: "#C0C0C0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7783,
    y: 34,
    width: 4,
    height: 2,
    fill: "#C0C0C0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7783,
    y: 6,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7783,
    y: 14,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7783,
    y: 22,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    y: 6,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7783,
    y: 6,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    y: 14,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7783,
    y: 14,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    y: 22,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7783,
    y: 22,
    width: 4,
    height: 4,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_10712"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77832 0.999999C6.77832 0.447714 7.22604 0 7.77832 0H37.7783C38.3306 0 38.7783 0.447715 38.7783 1V44H6.77832V0.999999Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIconOffice);
export default __webpack_public_path__ + "static/media/houseIconOffice.4941c21f1215c83f86099bf82c7c1446.svg";
export { ForwardRef as ReactComponent };